import { CreateNewPharmacyFormValuesType } from "~/common/types/pharmacyForm";
import { useCreatePatientPharmacy } from "./useCreatePatientPharmacy";
import { useUpdatePatientPharmacy } from "./useUpdatePatientPharmacy";

interface UpsertPharmacyProps {
  formData: CreateNewPharmacyFormValuesType;
  pharmacyId?: string;
}

export const useUpsertPatientPharmacy = (
  onClose: () => void,
  patientId?: string,
) => {
  const { createPatientPharmacyMutation, isPending: isCreatePharmacyPending } =
    useCreatePatientPharmacy(onClose, patientId);
  const { updatePatientPharmacyMutation, isPending: isUpdatePharmacyPending } =
    useUpdatePatientPharmacy(onClose, patientId);

  const upsertPharmacy = ({ formData, pharmacyId }: UpsertPharmacyProps) => {
    pharmacyId &&
      updatePatientPharmacyMutation({
        pharmacy: {
          ...formData,
          is_default: formData.is_default,
        },
        pharmacyId: pharmacyId,
      });

    !pharmacyId &&
      createPatientPharmacyMutation({
        ...formData,
        is_default: formData.is_default,
      });
  };

  const isPending = isCreatePharmacyPending || isUpdatePharmacyPending;

  return { upsertPharmacy, isPending };
};
